'use strict';

import React from 'react';
import { Row, Col, Input, Table, Modal } from 'antd';

class Dnd_SgiFormEditorRPSelect extends React.Component {

    constructor(props) {
        super(props);

        let ap = tool.Global.currentAP;
        let type = props.type;
        let catId;
        switch (type) {
            case "IR":
                catId = ap + "_RP_IR_0001";
                break;
            case "SR":
                catId = ap + "_RP_SR_0001";
                break;
            case "VR":
                catId = ap + "_RP_VR_0001";
                break;

            default:
                break;
        }

        let prm = PrmFactory.getPrm(catId) || {};
        let rps = tool.getAllLeaf(prm, "cldSet") || [];

        this.state = {
            loading: false,//加载标志
            selValues: {}, //查询条件
            store: rps,//表格的store
            selStore: rps, //给查询用的，保证永远都是最全的
            attname: this.props.attname,//对应属性名不一定一样
            preVisible: false,//图片预览课件标志
            preSrc: "",//图片预览路径
            preAlt: ""//图片预览alt
        };
    }

    columns_IR = [{
        title: '显示名称',
        dataIndex: 'te',
        width: 40
    }, {
        title: 'GUID',
        dataIndex: 'guid',
        width: 80
    }, {
        title: '图片预览',
        dataIndex: 'c',
        width: 40,
        render: (text, record, index) => {
            return (
                <img src={text} alt={record.te}
                    style={{ width: 35, height: 35 }}
                    onClick={(e) => {
                        this.setState({
                            preVisible: true,
                            preSrc: e.target.src,
                            preAlt: e.target.alt
                        })
                    }}
                />
            );
        }
    }]

    //及时筛选
    selOnChange(attname, e, e2) {
        let value = e.target.value;
        this.state.selValues[attname] = value;
        this.setState({ loading: false });
        this.onSel();
    }

    //筛选方法
    onSel() {
        const { mat } = this.state.selValues;
        if (!mat) {
            this.setState(this.state.selStore);
        }
        let reg;
        if (mat) {
            reg = new RegExp(mat, 'gi');
        }
        this.setState({
            store: this.state.selStore.filter((e, i, a) => {
                return (e.te ? e.te.match(reg) : false) || (e.guid ? e.guid.match(reg) : false) || (e.c ? e.c.match(reg) : false);
            })
        });
    }

    //双击选中事件
    onDoubleClick(record) {
        let p = this.props.parentModule;
        let values = p.state.values;
        let val = record.guid;
        let attname = this.state.attname;
        values[attname] = val;
        p.setState({ RPModalVisible: false });

        p.refresh(attname, val);
    }

    render() {

        return (
            <div style={{ height: '100%', width: '100%' }}>
                <Row style={{ margin: '5px 0px 5px 0px' }}>
                    <Col span={10} style={{ margin: "0px 5px 0px 5px" }}>
                        <Input addonBefore="筛选条件" value={this.state.selValues.mat} onChange={this.selOnChange.bind(this, 'mat')} />
                    </Col>
                </Row>
                <Row>
                    <Table size="small" dataSource={this.state.store} rowKey={'guid'} columns={this.columns_IR}
                        // onRowClick={this.onClick.bind(this)}
                        onRowDoubleClick={this.onDoubleClick.bind(this)}
                    />
                </Row>
                <Modal visible={this.state.preVisible} closable={false}
                    onCancel={() => { this.setState({ preVisible: false }) }}
                    footer={null}
                >
                    <img src={this.state.preSrc} alt={this.state.preAlt}
                        style={{ width: "100%", height: "100%" }}
                    // onMouseOut={() => { this.setState({ preVisible: false }) }}
                    />
                </Modal>
            </div>
        )
    }

}

export default Dnd_SgiFormEditorRPSelect;


// WEBPACK FOOTER //
// ./~/rt-sd-dnd/sgiDndDev/Dnd_SgiFormEditorRPSelect.js